/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 */

import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../constants/AgenticServiceConstants';
import utils from '../../../../common/utils';

export default class GetAgenticGraphService extends BaseService {
  constructor() {
    super(constants.GET_AGENTIC_GRAPH, 'GetAgenticGraphServiceStatus');
  }

  getErrorMessage(data, fallback) {
    return data?.error || data?.message || fallback;
  }

  async handleEvent(eventName, event) {
    const { payload, headers } = utils.buildRequestPartsFromPayload(event);
    const { graphId, version } = payload;
    const requestConfig = { headers, params: { version } };
    const { isStackB } = utils.getStackBParams();

    if (isStackB) {
      const enhancedHeaders = await utils.resolveStackBHeaders(headers);
      return this.getClient('aiadminstackb').get(`/graphs/${graphId}`, {
        ...requestConfig,
        headers: enhancedHeaders
      });
    }
    return this.getClient('aiadmin').get(`/graphs/${graphId}`, requestConfig);
  }

  handleResponse(response) {
    const { data } = response;
    const agenticGraphModel = Framework.getStoreRegistry().getStore('agenticGraphModel');

    if (data && data.success) {
      agenticGraphModel.clearError();
      agenticGraphModel.setGraphData(data);
      Framework.getEventManager().publish(constants.GET_AGENTIC_GRAPH_SUCCESS, { data });
    } else {
      const msg = this.getErrorMessage(data, 'Unknown error');
      const notification = {
        open: true,
        type: 'error',
        message: `Error loading graph: ${msg}`
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
      agenticGraphModel.setError(msg);
      Framework.getEventManager().publish(constants.GET_AGENTIC_GRAPH_ERROR);
    }
  }

  handleError(error) {
    const agenticGraphModel = Framework.getStoreRegistry().getStore('agenticGraphModel');
    const { response } = error;

    if (response) {
      const { status, data } = response;
      if (status === 401) {
        utils.redirectToLogin();
      }
      const msg = this.getErrorMessage(data, 'Failed to load graph. Please try again.');
      const notification = {
        open: true,
        message: msg,
        type: 'error'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
      agenticGraphModel.setError(msg);
    } else if (error.message === 'timeout of 60000ms exceeded') {
      const notification = {
        open: true,
        message: 'Request timeout. Please try again.',
        type: 'error'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
      agenticGraphModel.setError('Request timeout. Please try again.');
    }
    Framework.getEventManager().publish(constants.GET_AGENTIC_GRAPH_ERROR);
  }
}
